var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.818 14.125c-.616-.715-1.675-.678-2.503-.225A8.96 8.96 0 0 1 12 15a8.96 8.96 0 0 1-4.315-1.1c-.828-.453-1.887-.49-2.503.225A8.965 8.965 0 0 0 3 20v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1a8.965 8.965 0 0 0-2.182-5.875Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6A5 5 0 1 1 7 6a5 5 0 0 1 10 0Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;